import * as adapters from 'global/form/validationAdapters';
import { Events } from 'global/constants';

class FieldControl {
	constructor(fieldNode, rules) {
		this.field = fieldNode;
		this.rules = rules;
		this.valid = [];
		this.invalid = [];
		this.isValid = true;
		this.formText = this.getFieldFormText();
		this.eventType = this.field.getAttribute('data-validation-event') || 'blur';
		this.validationHandler = this.validateField.bind(this);

		this.attachFieldEvents();
	}

	attachFieldEvents() {
		this.field.addEventListener(this.eventType, this.validationHandler);
	}

	removeFieldEvents() {
		this.field.removeEventListener(this.eventType, this.validationHandler);
	}

	validateField() {
		this.valid = this.getValidFieldRules();
		this.invalid = this.getInvalidFieldRules();
		this.isValid = this.isOptional() || !this.overriddenFilter().length;

		this.updateFieldState();
		window.od.events.publish(Events.VALIDATION, {
			payload: {
				field: this.field,
				valid: this.valid,
				invalid: this.invalid,
				isValid: this.isValid,
			},
		});
		return this.isValid;
	}

	getValidFieldRules() {
		return Object.keys(this.rules).filter(key => this.validateRule(key));
	}

	validateRule(key) {
		if (!Object.prototype.hasOwnProperty.call(adapters, key)) {
			throw new Error(`No adapter for ${key}`);
		}

		const { rule } = this.rules[key];

		return adapters[key](this.valueToValidate(), rule);
	}

	valueToValidate() {
		const { value, checked } = this.field;

		return this.field.type === 'checkbox' ? checked : value;
	}

	getInvalidFieldRules() {
		return Object.keys(this.rules).filter(key => this.valid.indexOf(key) < 0);
	}

	updateFieldState() {
		this.resetFieldErrorMessage();
		this.updateFieldErrorClass();
		this.updateFieldErrorMessage();
	}

	isOptional() {
		return (
			typeof this.rules.required === 'undefined' && this.field.value === ''
		);
	}

	isOverridden(key) {
		const dataOverrides = this.field.getAttribute('data-override');
		return (
			dataOverrides && !!dataOverrides.split(';').find(item => item === key)
		);
	}

	overriddenFilter() {
		return this.invalid.filter(key => !this.isOverridden(key));
	}

	requiredRuleFilter(invalidList) {
		return invalidList.includes('required')
			? invalidList.filter(key => key === 'required')
			: invalidList;
	}

	updateFieldErrorClass() {
		if (this.isValid || this.isOptional()) {
			this.field.classList.remove('is-invalid');
		} else {
			this.field.classList.add('is-invalid');
		}
	}

	updateFieldErrorMessage() {
		if (
			(!this.isValid && !this.isOptional() && !this.isOverridden('required')) ||
			(!this.isValid && this.isOverridden('required'))
		) {
			let invalidList = this.overriddenFilter();
			invalidList = this.requiredRuleFilter(invalidList);

			invalidList.forEach(key => {
				const { message } = this.rules[key];
				const error = document.createElement('span');
				error.id = `${this.field.name}.${key}`;
				error.innerHTML = message;
				this.formText.appendChild(error);
			});
		}
	}

	resetFieldErrorMessage() {
		if (!this.formText) {
			this.formText = this.createFieldFormText();
		} else {
			this.formText.innerHTML = '';
		}
	}

	getFieldFormText() {
		const formGroup = this.field?.closest('.form-group');
		return formGroup?.querySelector('.form-text-errors');
	}

	createFieldFormText() {
		const formGroup = this.field.closest('.form-group');
		const formTextElement = document.createElement('div');
		formTextElement.classList.add(
			'form-text',
			'text-danger',
			'form-text-errors',
		);

		formGroup.appendChild(formTextElement);
		return formTextElement;
	}

	getFieldName() {
		return this.field.name;
	}
}

export default FieldControl;
